import { render } from "./LinkedinIcon.vue?vue&type=template&id=244569bd"
import script from "./LinkedinIcon.vue?vue&type=script&lang=js"
export * from "./LinkedinIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__